/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAccessTokenFromLocalStorage } from "../utilities/token-util";
export class BaseClientDMI {
  public async transformOptions(options: RequestInit): Promise<RequestInit> {
    return options;
  }
}

export class Client extends BaseClientDMI {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    main(api: Api, schema: Schema, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/{schema}?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMain(_response);
        });
    }

    protected processMain(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    keyvalue(key: string, value: string, api: Api2, schema: Schema2, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/{schema}/{key}/{value}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processKeyvalue(_response);
        });
    }

    protected processKeyvalue(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param key2 key2
     * @param value2 value2
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    doubleKeyvalue(key: string, value: string, key2: string, value2: string, api: Api3, schema: Schema3, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/{schema}/{key}/{value}/{key2}/{value2}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (key2 === undefined || key2 === null)
            throw new Error("The parameter 'key2' must be defined.");
        url_ = url_.replace("{key2}", encodeURIComponent("" + key2));
        if (value2 === undefined || value2 === null)
            throw new Error("The parameter 'value2' must be defined.");
        url_ = url_.replace("{value2}", encodeURIComponent("" + value2));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDoubleKeyvalue(_response);
        });
    }

    protected processDoubleKeyvalue(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationMain(api: Api4, schema: Schema4, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationMain(_response);
        });
    }

    protected processObservationMain(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationLatest(api: Api5, schema: Schema5, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation?latest?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationLatest(_response);
        });
    }

    protected processObservationLatest(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationLatest10Min(api: Api6, schema: Schema6, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation?latest-10-minutes?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationLatest10Min(_response);
        });
    }

    protected processObservationLatest10Min(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationLatestHour(api: Api7, schema: Schema7, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation?latest-hour?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationLatestHour(_response);
        });
    }

    protected processObservationLatestHour(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationLatestWeek(api: Api8, schema: Schema8, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation?latest-week?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationLatestWeek(_response);
        });
    }

    protected processObservationLatestWeek(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationLatestMonth(api: Api9, schema: Schema9, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation?latest-month?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationLatestMonth(_response);
        });
    }

    protected processObservationLatestMonth(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param stationId the id of the station to be queried fx. 06184
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationStation(stationId: string, api: Api10, schema: Schema10, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation/stationId/{station-id}?";
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationStation(_response);
        });
    }

    protected processObservationStation(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param parameterId the parameter to be queried fx. temp_dry or wind_speed
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationParameter(parameterId: string, api: Api11, schema: Schema11, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation/parameterId/{parameter-id}?";
        if (parameterId === undefined || parameterId === null)
            throw new Error("The parameter 'parameterId' must be defined.");
        url_ = url_.replace("{parameterId}", encodeURIComponent("" + parameterId));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationParameter(_response);
        });
    }

    protected processObservationParameter(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param stationId the id of the station to be queried fx. 06184
     * @param key2 key2
     * @param value2 value2
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationStationPlus(stationId: string, key2: string, value2: string, api: Api12, schema: Schema12, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation/stationId/{station-id}/{key2}/{value2}?";
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (key2 === undefined || key2 === null)
            throw new Error("The parameter 'key2' must be defined.");
        url_ = url_.replace("{key2}", encodeURIComponent("" + key2));
        if (value2 === undefined || value2 === null)
            throw new Error("The parameter 'value2' must be defined.");
        url_ = url_.replace("{value2}", encodeURIComponent("" + value2));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationStationPlus(_response);
        });
    }

    protected processObservationStationPlus(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param parameterId the parameter to be queried fx. temp_dry or wind_speed
     * @param key2 key2
     * @param value2 value2
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationParameterPlus(parameterId: string, key2: string, value2: string, api: Api13, schema: Schema13, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation/parameterId/{parameter-id}/{key2}/{value2}?";
        if (parameterId === undefined || parameterId === null)
            throw new Error("The parameter 'parameterId' must be defined.");
        url_ = url_.replace("{parameterId}", encodeURIComponent("" + parameterId));
        if (key2 === undefined || key2 === null)
            throw new Error("The parameter 'key2' must be defined.");
        url_ = url_.replace("{key2}", encodeURIComponent("" + key2));
        if (value2 === undefined || value2 === null)
            throw new Error("The parameter 'value2' must be defined.");
        url_ = url_.replace("{value2}", encodeURIComponent("" + value2));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationParameterPlus(_response);
        });
    }

    protected processObservationParameterPlus(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationsPlus(key: string, value: string, api: Api14, schema: Schema14, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation/{key}/{value}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationsPlus(_response);
        });
    }

    protected processObservationsPlus(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param key2 key2
     * @param value2 value2
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    observationPlusPlus(key: string, value: string, key2: string, value2: string, api: Api15, schema: Schema15, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/observation/{key}/{value}/{key2}/{value2}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (key2 === undefined || key2 === null)
            throw new Error("The parameter 'key2' must be defined.");
        url_ = url_.replace("{key2}", encodeURIComponent("" + key2));
        if (value2 === undefined || value2 === null)
            throw new Error("The parameter 'value2' must be defined.");
        url_ = url_.replace("{value2}", encodeURIComponent("" + value2));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processObservationPlusPlus(_response);
        });
    }

    protected processObservationPlusPlus(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    station(api: Api16, schema: Schema16, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/station?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStation(_response);
        });
    }

    protected processStation(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param stationId the id of the station to be queried fx. 06184
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    stationWithId(stationId: string, api: Api17, schema: Schema17, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/station/stationId/{station-id}?";
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStationWithId(_response);
        });
    }

    protected processStationWithId(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    stationsKeyValue(key: string, value: string, api: Api18, schema: Schema18, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/station/{key}/{value}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStationsKeyValue(_response);
        });
    }

    protected processStationsKeyValue(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param key2 key2
     * @param value2 value2
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    stationsKeyValuePlus(key: string, value: string, key2: string, value2: string, api: Api19, schema: Schema19, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/station/{key}/{value}/{key2}/{value2}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (key2 === undefined || key2 === null)
            throw new Error("The parameter 'key2' must be defined.");
        url_ = url_.replace("{key2}", encodeURIComponent("" + key2));
        if (value2 === undefined || value2 === null)
            throw new Error("The parameter 'value2' must be defined.");
        url_ = url_.replace("{value2}", encodeURIComponent("" + value2));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStationsKeyValuePlus(_response);
        });
    }

    protected processStationsKeyValuePlus(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    parameter(api: Api20, schema: Schema20, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/parameter?";
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParameter(_response);
        });
    }

    protected processParameter(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    parameterKeyValue(key: string, value: string, api: Api21, schema: Schema21, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/parameter/{key}/{value}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParameterKeyValue(_response);
        });
    }

    protected processParameterKeyValue(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param key key
     * @param value value
     * @param key2 key2
     * @param value2 value2
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    parameterKeyValuePlus(key: string, value: string, key2: string, value2: string, api: Api22, schema: Schema22, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/parameter/{key}/{value}/{key2}/{value2}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        if (key2 === undefined || key2 === null)
            throw new Error("The parameter 'key2' must be defined.");
        url_ = url_.replace("{key2}", encodeURIComponent("" + key2));
        if (value2 === undefined || value2 === null)
            throw new Error("The parameter 'value2' must be defined.");
        url_ = url_.replace("{value2}", encodeURIComponent("" + value2));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParameterKeyValuePlus(_response);
        });
    }

    protected processParameterKeyValuePlus(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }

    /**
     * @param parameterId the parameter to be queried fx. temp_dry or wind_speed
     * @param api the api to be queried
     * @param schema the schema to be queried
     * @param api_key only call with your api key
     * @param from (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param to (optional) timestamp value for which to filter on an Observation's timeObserved<br>
     ,For an EPOCH-converter see here: https://www.epochconverter.com/<br>
     fx. ...v1/observation?from=1562498400000000<br>
     fx. ...v1/observation?from=1562498400000000&to=1562502000000000
     * @param limit (optional) number of results to return, max<br>
    fx. ...v1/observation?limit=2
     * @param offset (optional) number of results to skip before returning matching results<br>
    fx. ...v1/observation?offset=1000
     * @param field (optional) return only the given <field> in the response<br>
    fx. ...v1/observation?field=value
     * @return Example Observation Response
     */
    parameterWithId(parameterId: string, api: Api23, schema: Schema23, api_key: string, from: string | undefined, to: string | undefined, limit: string | undefined, offset: string | undefined, field: string | undefined): Promise<Observation> {
        let url_ = this.baseUrl + "/{api}/v1/parameter/parameterId/{parameter-id}?";
        if (parameterId === undefined || parameterId === null)
            throw new Error("The parameter 'parameterId' must be defined.");
        url_ = url_.replace("{parameterId}", encodeURIComponent("" + parameterId));
        if (api === undefined || api === null)
            throw new Error("The parameter 'api' must be defined.");
        url_ = url_.replace("{api}", encodeURIComponent("" + api));
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (api_key === undefined || api_key === null)
            throw new Error("The parameter 'api_key' must be defined and cannot be null.");
        else
            url_ += "api-key=" + encodeURIComponent("" + api_key) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (field === null)
            throw new Error("The parameter 'field' cannot be null.");
        else if (field !== undefined)
            url_ += "field=" + encodeURIComponent("" + field) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processParameterWithId(_response);
        });
    }

    protected processParameterWithId(response: Response): Promise<Observation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Observation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("a 204 response : No content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorMessage.fromJS(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("a 401 response : Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("a 404 response : Not found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("a 500 response : Internal server error", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("a 503 response : Service temporarily unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Observation>(<any>null);
    }
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Observation field descriptions</a></small> */
export class Observation implements IObservation {
    get_id?: string;
    parameterId?: string;
    stationId?: string;
    timeCreated?: number;
    timeObserved?: number;
    value?: any;
    qc?: string;

    constructor(data?: IObservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.get_id = _data["get_id"];
            this.parameterId = _data["parameterId"];
            this.stationId = _data["stationId"];
            this.timeCreated = _data["timeCreated"];
            this.timeObserved = _data["timeObserved"];
            this.value = _data["value"];
            this.qc = _data["qc"];
        }
    }

    static fromJS(data: any): Observation[] {
      data = typeof data === 'object' ? data : {};
      let result = Array<Observation>();
      data.forEach((observation: Observation) => {
        result.push(observation);
      });
      return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["get_id"] = this.get_id;
        data["parameterId"] = this.parameterId;
        data["stationId"] = this.stationId;
        data["timeCreated"] = this.timeCreated;
        data["timeObserved"] = this.timeObserved;
        data["value"] = this.value;
        data["qc"] = this.qc;
        return data; 
    }
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Observation field descriptions</a></small> */
export interface IObservation {
    get_id?: string;
    parameterId?: string;
    stationId?: string;
    timeCreated?: number;
    timeObserved?: number;
    value?: any;
    qc?: string;
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Location field descriptions</a></small> */
export class Location implements ILocation {
    latitude?: number;
    longitude?: number;
    height?: number;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["height"] = this.height;
        return data; 
    }
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Location field descriptions</a></small> */
export interface ILocation {
    latitude?: number;
    longitude?: number;
    height?: number;
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Station field descriptions</a></small> */
export class Station implements IStation {
    get_id?: string;
    location?: Location;
    instrumentParameter?: InstrumentParameter[];
    name?: string;
    owner?: number;
    regionId?: string;
    stationId?: string;
    parameterId?: string[];
    status?: number;
    wmoContryCode?: string;
    wmoStationId?: string;
    timeCreated?: number;
    timeOperationEnd?: number;
    timeOperationStart?: number;
    timeUpdated?: number;
    timeValidTo?: number;
    timeValidFrom?: number;

    constructor(data?: IStation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.get_id = _data["get_id"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["instrumentParameter"])) {
                this.instrumentParameter = [] as any;
                for (let item of _data["instrumentParameter"])
                    this.instrumentParameter!.push(InstrumentParameter.fromJS(item));
            }
            this.name = _data["name"];
            this.owner = _data["owner"];
            this.regionId = _data["regionId"];
            this.stationId = _data["stationId"];
            if (Array.isArray(_data["parameterId"])) {
                this.parameterId = [] as any;
                for (let item of _data["parameterId"])
                    this.parameterId!.push(item);
            }
            this.status = _data["status"];
            this.wmoContryCode = _data["wmoContryCode"];
            this.wmoStationId = _data["wmoStationId"];
            this.timeCreated = _data["timeCreated"];
            this.timeOperationEnd = _data["timeOperationEnd"];
            this.timeOperationStart = _data["timeOperationStart"];
            this.timeUpdated = _data["timeUpdated"];
            this.timeValidTo = _data["timeValidTo"];
            this.timeValidFrom = _data["timeValidFrom"];
        }
    }

    static fromJS(data: any): Station {
        data = typeof data === 'object' ? data : {};
        let result = new Station();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["get_id"] = this.get_id;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.instrumentParameter)) {
            data["instrumentParameter"] = [];
            for (let item of this.instrumentParameter)
                data["instrumentParameter"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["regionId"] = this.regionId;
        data["stationId"] = this.stationId;
        if (Array.isArray(this.parameterId)) {
            data["parameterId"] = [];
            for (let item of this.parameterId)
                data["parameterId"].push(item);
        }
        data["status"] = this.status;
        data["wmoContryCode"] = this.wmoContryCode;
        data["wmoStationId"] = this.wmoStationId;
        data["timeCreated"] = this.timeCreated;
        data["timeOperationEnd"] = this.timeOperationEnd;
        data["timeOperationStart"] = this.timeOperationStart;
        data["timeUpdated"] = this.timeUpdated;
        data["timeValidTo"] = this.timeValidTo;
        data["timeValidFrom"] = this.timeValidFrom;
        return data; 
    }
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Station field descriptions</a></small> */
export interface IStation {
    get_id?: string;
    location?: Location;
    instrumentParameter?: InstrumentParameter[];
    name?: string;
    owner?: number;
    regionId?: string;
    stationId?: string;
    parameterId?: string[];
    status?: number;
    wmoContryCode?: string;
    wmoStationId?: string;
    timeCreated?: number;
    timeOperationEnd?: number;
    timeOperationStart?: number;
    timeUpdated?: number;
    timeValidTo?: number;
    timeValidFrom?: number;
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Parameter field descriptions</a></small> */
export class Parameter implements IParameter {
    get_id?: string;
    parameterId?: string;
    description?: string;
    number?: number;
    timeCreated?: number;
    timeUpdated?: number;
    timeValidFrom?: number;
    timeValidTo?: number;
    unit?: string;

    constructor(data?: IParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.get_id = _data["get_id"];
            this.parameterId = _data["parameterId"];
            this.description = _data["description"];
            this.number = _data["number"];
            this.timeCreated = _data["timeCreated"];
            this.timeUpdated = _data["timeUpdated"];
            this.timeValidFrom = _data["timeValidFrom"];
            this.timeValidTo = _data["timeValidTo"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Parameter {
        data = typeof data === 'object' ? data : {};
        let result = new Parameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["get_id"] = this.get_id;
        data["parameterId"] = this.parameterId;
        data["description"] = this.description;
        data["number"] = this.number;
        data["timeCreated"] = this.timeCreated;
        data["timeUpdated"] = this.timeUpdated;
        data["timeValidFrom"] = this.timeValidFrom;
        data["timeValidTo"] = this.timeValidTo;
        data["unit"] = this.unit;
        return data; 
    }
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Parameter field descriptions</a></small> */
export interface IParameter {
    get_id?: string;
    parameterId?: string;
    description?: string;
    number?: number;
    timeCreated?: number;
    timeUpdated?: number;
    timeValidFrom?: number;
    timeValidTo?: number;
    unit?: string;
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Instrument Parameter field descriptions</a></small> */
export class InstrumentParameter implements IInstrumentParameter {
    parameterId?: string;
    value?: number;

    constructor(data?: IInstrumentParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterId = _data["parameterId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InstrumentParameter {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterId"] = this.parameterId;
        data["value"] = this.value;
        return data; 
    }
}

/** <small><a href="https://confluence.govcloud.dk/display/FDAPI/Schemas">Click here to see Instrument Parameter field descriptions</a></small> */
export interface IInstrumentParameter {
    parameterId?: string;
    value?: number;
}

export class ErrorMessage implements IErrorMessage {
    message?: string;

    constructor(data?: IErrorMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data; 
    }
}

export interface IErrorMessage {
    message?: string;
}

export enum Api {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api2 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema2 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api3 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema3 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api4 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema4 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api5 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema5 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api6 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema6 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api7 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema7 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api8 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema8 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api9 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema9 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api10 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema10 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api11 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema11 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api12 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema12 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api13 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema13 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api14 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema14 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api15 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema15 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api16 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema16 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api17 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema17 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api18 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema18 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api19 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema19 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api20 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema20 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api21 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema21 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api22 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema22 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export enum Api23 {
    MetObs = "metObs",
    OceanObs = "oceanObs",
}

export enum Schema23 {
    Observation = "observation",
    Station = "station",
    Parameter = "parameter",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

// This class is copied to api.ts when running codegen.